import { IPageParams } from "gen/ApiClient";

interface IParams {
    pageParams: IPageParams;
}

export const onResetToPage1 = <TParams extends IParams>(params: TParams): TParams => {
    return ({ ...params, pageParams: { ...params.pageParams, index: 1 } });
}